<div *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
    [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadCsvFormato()">
  </app-lfsa-card>
  <ng-template #carga>
    <!-- <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'version'" [idOpcion]="'id'"
            [comboBox]="listaDeVersiones" formControlName="version" [control]="formulario.get('version')"
            [label]="'Versión *'" [id]="'version'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbTipoDePresupuesto" formControlName="opcion" [control]="formulario.get('opcion')"
            [label]="'Tipo de Presupuesto *'" [id]="'opcion'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-3">
          <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp;
          <label for="csvInput" class="letrasDanger">{{ titulo }}.csv*</label>
          <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
            accept=".csv" />
        </div>
        <div class="form-group col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbOpcionesV2" formControlName="conversor" [control]="formulario.get('conversor')"
            [label]="'Convertir a Cajas*'" [id]="'conversor'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-3">
          <label for="">&nbsp;</label>
          <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
            class="zatras btn btn-success btn-block">Procesar</button>
        </div>
      </div>
    </form> -->
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-md-4">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAnio"
          formControlName="anio" [control]="formulario.get('anio')" [label]="'Año*'" [id]="'anio'">
        </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-4">
          <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp;
          <label for="csvInput" class="letrasDanger">{{ titulo }}.csv*</label>
          <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
            accept=".csv" />
        </div>
        <div class="form-group col-md-4">
          <label for="">&nbsp;</label>
          <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
            class="zatras btn btn-success btn-block">Procesar</button>
        </div>
      </div>
    </form>

    <!-- {{ formulario.value | json }} -->
    <br>
    <br>
    <br>
  </ng-template>
</div>

<div *ngIf="mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'CARGAR DE ARCHIVO'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadDataCsv()"></app-lfsa-card>
  <ng-template #grid>
    <div class="alert alert-danger" role="alert" *ngIf="listaVacia">
      No existen datos para la lista.
    </div>
    <br>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" class="{{modulo.agGrid.class}}" 
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" id="{{modulo.agGrid.id}}"
      [columnDefs]="columnDefs" [rowSelection]="rowSelection"
      [ngStyle] = "modulo.agGrid.style" [paginationPageSize] = "modulo.agGrid.paginacion"
      [pagination] ="true" 
      [rowData] = "rowData" >
    </ag-grid-angular>
  </ng-template>
  <div class="row">
    <div class="form-group col-md-6">
      <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="errorData" (click)="guardar()" class="btn btn-outline-success btn-block btn-lg">Guardar</button>
    </div>
  </div>
  <br>
  <br>
</div>